import type { ListBuilderList } from '../../../types';
import { createStandardOrderColumns } from '../columns';
import {
	ORDER_MOBILE_CARD_CONFIG,
	ORDER_REQUIRED_FIELDS,
	SALES_REP_FILTER_RULES,
} from '../shared';

/**
 * Requires Approval list configuration
 * Orders requiring approval - filtered for 'Approval Required' status
 */
export const requiringApprovalOrdersList: ListBuilderList = {
	id: 'requiring-approval-orders',
	cacheTTL: 600000,
	name: 'Requires Approval',
	type: 'default',
	active: true,
	sortOrder: 1,
	requiredFeature: 'order-entry',
	columns: createStandardOrderColumns(),
	mobileCardConfig: ORDER_MOBILE_CARD_CONFIG,
	description:
		"Orders requiring approval - filtered for 'Approval Required' status",
	defaultSortId: 'column-dates-asc',
	requiredFields: ORDER_REQUIRED_FIELDS,
	filterRules: {
		...SALES_REP_FILTER_RULES,
		orderStatus: {
			defaultValue: [
				{
					id: '8',
					data: {
						id: '8',
						label: 'Approval Required',
					},
					label: 'Approval Required',
				},
			],
		},
	},
};
